import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import InfoSections from './components/InfoSections';
import ArticlesSection from './components/ArticlesSection';
import JsonLd from '@/components/feature/JsonLd';
import { SITE_URL, BRAND_NAME, FAVICON_URL } from '@/lib/seo';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: BRAND_NAME,
  url: `${SITE_URL}/`,
  description:
    'Explore USFans spreadsheet resources, reviews, shipping costs, coupons, discount codes, warehouse guides, safety information and useful resources.',
  inLanguage: ['en', 'pl', 'es', 'fr'],
};

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: BRAND_NAME,
  url: `${SITE_URL}/`,
  logo: FAVICON_URL,
};

export default function Home() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('home.hero.title');
  }, [t]);

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={[websiteJsonLd, organizationJsonLd]} />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <InfoSections />
        <ArticlesSection />
      </main>
      <Footer />
    </div>
  );
}